import { memo, useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Tabs } from 'antd';

import { VERTICAL_URL } from 'settings';
import TopPage from 'v2/components/Shared/TopPage';

import Product from './Product';

type ISubscriptionTabs = 'subscriptions' | 'products';

const SUBSCRIPTIONS_URL = `${VERTICAL_URL}/subscriptions/me`;

const Subscriptions = memo(() => {
  const { tabName } = useParams<{ tabName: ISubscriptionTabs }>();

  const [tab, setTab] = useState<ISubscriptionTabs>(() => {
    return 'products';
  });

  const redirectToSubscriptions = useCallback(() => {
    window.location.replace(SUBSCRIPTIONS_URL);
  }, []);

  useEffect(() => {
    if (tabName === 'subscriptions') {
      redirectToSubscriptions();
    }
  }, [redirectToSubscriptions, tabName]);

  const handleChange = useCallback(
    (tab: ISubscriptionTabs) => {
      if (tab === 'subscriptions') {
        redirectToSubscriptions();
        return;
      }

      setTab(tab);
    },
    [redirectToSubscriptions]
  );

  if (tabName === 'subscriptions') {
    return null;
  }

  return (
    <div>
      <div id='my-subscriptions' className='flex items-start justify-between'>
        <TopPage
          title='Minhas Compras'
          extra='Gerencie e acesse os produtos que você adquiriu dentro da plataforma Eduzz.'
        />
      </div>

      <div className='mt-4'>
        <Tabs
          className='mb-4'
          activeKey={tab}
          onChange={handleChange}
          items={[
            { key: 'products', label: 'Produtos', children: null },
            { key: 'subscriptions', label: 'Assinaturas', children: null }
          ]}
        />
        {tab === 'products' && <Product />}
      </div>
    </div>
  );
});

export default Subscriptions;
